import React, { useState } from 'react'
import { Document, Page } from 'react-pdf'
import AppConstants from '../../core-components/AppConstants'
import Loader from '../../core-components/Loader'
import classes from "./PaymentRequest.module.scss"
const Invoice = ({ invoiceId, companyId, token }) => {
    const docUrl = `${AppConstants.developmentAPIURL}payments/purchase-order/proforma-invoice?invoiceId=${invoiceId}&companyId=${companyId}&is_proforma_invoice=true&token=${token}`;
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(null);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const renderLoader = () => {
        return (
            <div className={classes.loaderContainer}>
                <Loader style={{ textAlign: 'center' }} />
            </div>
        )
    }
    return (
        <div className={classes.RenderLink}>
            <Document
                file={{ url: docUrl }}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={renderLoader}
                className='paymentDocument'
            >
                <Page pageNumber={pageNumber} />
            </Document>
        </div>
    )
}

export default React.memo(Invoice)